import { rankingIcons } from '@constants/icons';
import { usePumpRankingLaunching } from '@hooks/use-pump-ranking';
import { pumpSdk } from '@libs/pump';
import Loading from '@ui/loading';
import { formatDigitUnit } from '@utils/format-digit-unit';
import type { OpenapiClientPump } from 'src/openapi/pump';
import { type FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Decimal } from 'turbos-clmm-sdk';
import styles from './graduate.module.scss';
import Lottie from 'lottie-react';
import cardf1JSON from '@assets/lottie/pump/card-f1.json';
import Buy from '@components/buy';

const GraduateList: FC = () => {
  const navigate = useNavigate();
  const launching = usePumpRankingLaunching();
  const topData = launching.launching?.slice(0, 3);
  const finalMarketCap = launching.launching?.slice(3);

  if (!launching.launching) {
    return (
      <div className={styles.loading}>
        <Loading size={48} />
      </div>
    );
  }

  return (
    <div>
      <div className={styles.top}>
        {topData?.map((item, index) => {
          let ratio = new Decimal(item.real_sui_reserves)
            .div(pumpSdk.fair_launch_sui_amount)
            .mul(100)
            .toFixed(2);
          ratio = Number(ratio) > 100 ? '100' : ratio;
          return (
            <div
              className={styles.top_list}
              key={item.token_address}
              onClick={() => navigate(`/fun/${item.token_address}`)}
            >
              <div className={styles.token}>
                <img src={rankingIcons[index]} className={styles.token_icon} />
                <div className={styles.token_name}>
                  {item.token_metadata.name}(${item.token_metadata.symbol})
                </div>
                <Buy
                  token_address={item.token_address}
                  name={item.token_metadata.name}
                  symbol={item.token_metadata.symbol}
                  iconUrl={item.token_metadata.iconUrl}
                />
              </div>
              <div className={styles.token_info}>
                <div>
                  <img src={item.token_metadata.iconUrl} className={styles.token_icon} />
                </div>
                <div className={styles.right}>
                  <div className={styles.token_line}>
                    <div>Bonding Curve progress</div>
                    <div>{ratio}%</div>
                  </div>
                  <div className={styles.percent}>
                    <div className={styles.percent_bg}></div>
                    <div className={styles.width} style={{ width: `${ratio}%` }}></div>
                    <div className={styles.card} style={{ left: `${ratio}%` }}>
                      <Lottie animationData={cardf1JSON} autoplay loop className={styles.lottie} />
                    </div>
                  </div>
                  <div className={styles.token_line}>
                    <div>Market Cap</div>
                    <div>${formatDigitUnit(item.market_cap_usd, 2)}</div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.content}>
        {finalMarketCap?.map((item, index) => (
          <List key={item.token_address} item={item} index={index} />
        ))}
      </div>
    </div>
  );
};

const List: FC<{
  item: OpenapiClientPump.GetRankingsBoundingCurveResponse[number];
  index: number;
}> = ({ item, index }) => {
  const navigate = useNavigate();
  let ratio = new Decimal(item.real_sui_reserves)
    .div(pumpSdk.fair_launch_sui_amount)
    .mul(100)
    .toFixed(2);
  ratio = Number(ratio) > 100 ? '100' : ratio;

  return (
    <div className={styles.top_list} onClick={() => navigate(`/fun/${item.token_address}`)}>
      <div className={styles.token}>
        <div className={styles.token_index}>{index + 4}</div>
        <div className={styles.token_name}>
          {item.token_metadata.name}(${item.token_metadata.symbol})
        </div>
        <Buy
          token_address={item.token_address}
          name={item.token_metadata.name}
          symbol={item.token_metadata.symbol}
          iconUrl={item.token_metadata.iconUrl}
        />
      </div>
      <div className={styles.token_info}>
        <img src={item.token_metadata.iconUrl} className={styles.token_icon} />
        <div className={styles.right}>
          <div className={styles.token_line}>
            <div>Bonding Curve progress</div>
            <div>{ratio}%</div>
          </div>
          <div className={styles.percent}>
            <div className={styles.percent_bg}></div>
            <div className={styles.width} style={{ width: `${ratio}%` }}></div>
          </div>
          <div className={styles.token_line}>
            <div>Market Cap</div>
            <div>${formatDigitUnit(item.market_cap_usd, 2)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GraduateList;
